(function ( $ ) {

    $(document).ready(function () {

        setTimeout( function () {
            var locationHash = window.location.hash;
            var $scrollToBlock = $('#' + locationHash.replace('#scroll-', ''));
            if ( $scrollToBlock.length > 0 ) {
                $('html, body').animate({
                    scrollTop: $scrollToBlock.offset().top - document.documentElement.clientHeight * 0.2
                }, 700);
            }
        }, 200 );

    });
})( jQuery )
